import { AxiosInstance } from "axios"
import {
    OrderForCalendar,
    ReportDetails,
} from "../merchant/merchant/production/ordersForCalendar/ordersForCalendarTypes"
import { Product, ProductGroups } from "../merchant/admin/products/productsTypes"

export enum UserDetails {
    USER_CALENDAR_EVENTS = "user-calendar-events",
    USER_AVAILABLE_ROOMS = "user-available-rooms",
    USER_PRODUCTS_LIST = "user-products-list",
    USER_PRODUCT_DETAILS = "user-product-details",
}

export type FetchUserCalendarEventsResponse = Readonly<{
    reportDetails: ReportDetails | any
    orders: OrderForCalendar[]
}>

type FetchUserCalendarEventsParams = Readonly<{
    userId: number
    startDate: string
    endDate: string
}>

export async function fetchUserCalendarEvents(
    { userId, endDate, startDate }: FetchUserCalendarEventsParams,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<FetchUserCalendarEventsResponse> {
    const url = `/users/${userId}/events`

    const { data } = await axios.get(url, {
        params: {
            startDate,
            endDate,
        },
        signal,
    })

    return data
}

type FetchAvailableRoomsParams = Readonly<{
    locationId: number
    startDateTime: string | null
    endDateTime: string | null
}>

export type FetchAvailableRoomsResponse = Readonly<{
    availableRooms: { count: number }
}>

export async function fetchAvailableRooms(
    { locationId, startDateTime, endDateTime }: FetchAvailableRoomsParams,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<FetchAvailableRoomsResponse> {
    const url = `/locations/${locationId}/availableRooms`

    const { data } = await axios.get(url, {
        params: {
            startDateTime,
            endDateTime,
        },
        signal,
    })

    return data
}

// -- Fetch Products For User --
type FetchProductsForUserParams = Readonly<{
    userId: number
    merchantId: number
    priceListId?: number
    isActive?: boolean
    deliveryDate?: string
    mode?: "edit"
}>

export type FetchProductsForUserResponse = {
    productGroups: ProductGroups[]
}

export async function fetchProductsForUser(
    { userId, merchantId, ...rest }: FetchProductsForUserParams,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<FetchProductsForUserResponse> {
    const url = `/users/${userId}/merchants/${merchantId}/meetingService/products`

    const { data } = await axios.get(url, {
        params: rest,
        signal,
    })

    return data
}

type FetchProductDetailsForUserParams = Readonly<{
    userId: number
    productId: number
}>

export type FetchProductDetailsForUserResponse = {
    product: Product
}

export async function fetchProductDetailsForUser(
    { userId, productId }: FetchProductDetailsForUserParams,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<FetchProductDetailsForUserResponse> {
    const url = `/users/${userId}/products/${productId}`

    const { data } = await axios.get(url, {
        signal,
    })

    return data
}
